import { NotFound } from './pages';

export default {
  key: 'not-found',
  isPrivate: false,
  exact: true,
  path: '/not-found',
  component: NotFound,
};
